/* eslint-disable */

class filter {

  constructor() {

    this.$allActus = document.querySelectorAll('#map-page-interne .mapboxgl-canvas-container > .marker');
    this.$filtersWrapper = document.querySelector('.grid-wrapper-map > .map-legends');

    // data-* key name
    this.color = "color";
    this.addEventListener();

    console.log('hello from filter map');
    
  }

  addEventListener() {
    document.body.addEventListener('click', e => {
      this.handleFilterClick(e);
    })
  }

 
  handleFilterClick(e) {
    
    const isFilterWrapperClicked = this.$filtersWrapper.contains(e.target);
    if(isFilterWrapperClicked) {
      this.resetChanges();
      this.filterActus(e);
    }
  }

  filterActus(e) {

    this.$allActus.forEach( actu => {
      if(e.target.getAttribute(`data-${this.color}`)) this.subFilter(e.target, actu, this.color); 
    })
  }

  subFilter(target, item, dataKey) {
    if (item.getAttribute(`data-${dataKey}`) != target.getAttribute(`data-${dataKey}`)) {
      item.style.display = "none";
    }
  }


  resetChanges() {
    this.$allActus.forEach( actu => {
      if (actu.style.display === "none") actu.style.display = "block";
    })
  }
}

const pagePole = document.querySelector('body.page-template-template-pole');


if (pagePole) new filter();


// WEBPACK FOOTER //
// ./scripts/filter_map.js